// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

/*Utility class*/
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-image: linear-gradient(
    to right top,
    #8492ed,
    #c176d8,
    #ed52a8,
    #fd3a65,
    #eb4b12
  );
  padding: 10px 25px;
  border-radius: 20px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

body {
  min-height: 100vh;
  background: linear-gradient(to right, #000000, #434343);
  color: white;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

a {
  display: inline-block;
  text-decoration: none;
  color: white;
}

ul {
  list-style-type: none;
}

button {
  border: 0;
}

button:hover {
  cursor: pointer;
}

input {
  border: 0;
}

button:focus,
input:focus {
  outline: 0;
}

.w-1150 {
  margin: 0 auto;
  max-width: 1150px;
}
`, "",{"version":3,"sources":["webpack://./src/style/style.css"],"names":[],"mappings":"AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C;;;;;;;GAOC;EACD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600&display=swap');\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n/*Utility class*/\n.flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.card {\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  background-image: linear-gradient(\n    to right top,\n    #8492ed,\n    #c176d8,\n    #ed52a8,\n    #fd3a65,\n    #eb4b12\n  );\n  padding: 10px 25px;\n  border-radius: 20px;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Poppins', sans-serif;\n}\n\nbody {\n  min-height: 100vh;\n  background: linear-gradient(to right, #000000, #434343);\n  color: white;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\na {\n  display: inline-block;\n  text-decoration: none;\n  color: white;\n}\n\nul {\n  list-style-type: none;\n}\n\nbutton {\n  border: 0;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\ninput {\n  border: 0;\n}\n\nbutton:focus,\ninput:focus {\n  outline: 0;\n}\n\n.w-1150 {\n  margin: 0 auto;\n  max-width: 1150px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
